export const VUEX_FILTERBAR_OPTIONSLISTS_LIBRARYTYPE_SET = 'VUEX_FILTERBAR_OPTIONSLISTS_LIBRARYTYPE_SET'
export const VUEX_FILTERBAR_OPTIONSLISTS_FETCH = 'VUEX_FILTERBAR_OPTIONSLISTS_FETCH'
